// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODFIED DATA : 07-12-2025

import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************** FETCH CREDIT BUREAU REPORT START *********************** */
export const creditBureauReportListGet = (listData: any) => {
	const data = {
		GetCreditBureauReportToken: listData,
	};
	const url = `${API_URL}GetHighmarkCheckDetailsForBranchWithToken`;
	return makeApiCall(url, data);
};
/** ***************** FETCH CREDIT BUREAU REPORT END *********************** */
